import { DB_NAME, DB_VERSION, DEFAULT_WORKSPACE_NAME } from '../constants';

export const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      const oldVersion = e.oldVersion;

      if (!db.objectStoreNames.contains('workspaces')) {
        db.createObjectStore('workspaces', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('notes')) {
        const notesStore = db.createObjectStore('notes', { keyPath: 'id' });
        notesStore.createIndex('workspaceId', 'workspaceId', { unique: false });
      }
      if (!db.objectStoreNames.contains('templates')) {
        db.createObjectStore('templates', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('backups')) {
        db.createObjectStore('backups', { keyPath: 'id' });
      }

      // Migration for Version 2: Add archivedAt and ensure Title
      if (oldVersion < 2) {
        const tx = e.target.transaction;
        const notesStore = tx.objectStore('notes');
        const workspacesStore = tx.objectStore('workspaces');

        // Note Migrations
        notesStore.openCursor().onsuccess = (event) => {
          const cursor = event.target.result;
          if (cursor) {
            const note = cursor.value;
            const updatedNote = {
              ...note,
              archivedAt: note.archivedAt || null,
              createdViaQuickCapture: note.createdViaQuickCapture || false,
              title: note.title || (note.bodyText ? note.bodyText.slice(0, 40) : 'Untitled')
            };
            cursor.update(updatedNote);
            cursor.continue();
          }
        };

        // Workspace Migrations
        workspacesStore.openCursor().onsuccess = (event) => {
          const cursor = event.target.result;
          if (cursor) {
            const ws = cursor.value;
            cursor.update({ ...ws, archivedAt: ws.archivedAt || null });
            cursor.continue();
          }
        };
      }
    };

    request.onsuccess = async (e) => {
      const db = e.target.result;
      const tx = db.transaction('workspaces', 'readonly');
      const store = tx.objectStore('workspaces');
      const countReq = store.count();
      countReq.onsuccess = () => {
        if (countReq.result === 0) {
          const writeTx = db.transaction('workspaces', 'readwrite');
          writeTx.objectStore('workspaces').add({
            id: 'ws-default',
            name: DEFAULT_WORKSPACE_NAME,
            color: '#3B82F6',
            createdAt: Date.now(),
            updatedAt: Date.now(),
            archivedAt: null
          });
        }
      };
      resolve(db);
    };
    request.onerror = () => reject(request.error);
  });
};

const dbOp = async (storeName, mode, op) => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const store = tx.objectStore(storeName);
    const request = op(store);
    tx.oncomplete = () => resolve(request ? request.result : undefined);
    tx.onerror = () => reject(tx.error);
  });
};

export const dbGet = (store, id) => dbOp(store, 'readonly', s => s.get(id));
export const dbGetAll = (store) => dbOp(store, 'readonly', s => s.getAll());
export const dbPut = (store, item) => dbOp(store, 'readwrite', s => s.put(item));
export const dbDelete = (store, id) => dbOp(store, 'readwrite', s => s.delete(id));
export const dbClear = (store) => dbOp(store, 'readwrite', s => s.clear());